import React from 'react'
import AboutSection from './AboutSection'
import '../../../../css/Employer/Content.css'


const aboutParagraphs = [
    {
        content: "Microsoft Student Accelerator is a great way for your company to work on interesting, off-beat and innovative ideas. It is a chance to take a student team to your company over 10 weeks during the summer study break."
    },
    {
        content: "Students will be trained by Microsoft over various industry-relevant technologies such as React, JavaScript, C#, RESTful API, Microsoft Azure and more."
    },
    {
        content: "In return you would provide the student team with a dedicated mentor. This allows students to have an opportunity to be involved with your company and gain industry experience before they graduate!"
    }
]

const expectationsParagraph = [
    {
        content: "To ensure all participants gain value in the MSA programme, we have worked with past employers to set expectations for students as well as employers."
    },
    {
        content: "We encourage all employers to provide some form of compensation to students. Many employers choose to provide a stipend or cover expenses. Eligible organisations are encouraged to apply for the Callaghan Innovation fund, which may provide a source of funding to pay students a full-time wage."
    }
]

const ExpectationList = function() {
    return (
        <div className="purple-container py-5 container-fluid">
            <div className="container">
                <h4>We request that your organisation:</h4>
                <div className="expect-list pt-4">
                    <ul>
                        <li>Provide opportunities for students to be involved in a innovative collaborative project to work on over the 10-week period</li>
                        <li>Involve students in company activities where possible, and help them gain insight on how your organisation operates</li>
                        <li>Assign them a dedicated mentor</li>
                        <li>Offer students opportunities for professional development</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

function About() {
    return (
        <div>
            <div className="about bg-light container-fluid pt-5 pb-5">
                <AboutSection title="About" paragraphs={aboutParagraphs} />
            </div>
            <div className="about bg-white container-fluid pt-5 pb-5">
                <div className="pb-5">
                    <AboutSection title="Expectations" paragraphs={[expectationsParagraph[0]]} />
                </div>
                { ExpectationList() }
                <div className="pt-5">
                    <AboutSection title="" paragraphs={[expectationsParagraph[1]]}/>
                </div>
            </div>
        </div>
    )
}

export default About;
